import _ from 'lodash';
import config from '../config';
import playerConfig from '../config/player.json';
import partnerConfigs from '../config/partners.json';
import getPartnerConfig from '../util/getPartnerConfig';

const { CONFIG_PROFILE } = config;
const configEnv = (CONFIG_PROFILE === 'prod' || CONFIG_PROFILE === 'stage' || CONFIG_PROFILE === 'special') ? 'prod' : 'test';
//const configEnv = 'prod';
const fallbackVideoAssetIds = {
  dk: '102607288',
};

function freewheelConfig(configs, country, video, csid, sovSeed, cuePoints, inline) {
  const kruxParams = _(_.get(window, 'playStorage.data.tracking.segments')).invert().mapValues(() => '1').value();

  configs.videoAssetId = video.fwAssetId || fallbackVideoAssetIds[country];
  configs.siteSectionId = csid;
  configs.showDisplayAds = inline ? false : true;
  configs.adRequestKeyValues = _.merge({}, kruxParams, { sov_seed: sovSeed });
  configs.midrollCuepoints = cuePoints;
  return configs;
}

function comscoreConfig(configs, article, video, country) {
  const sport = _.get(article, `tags.sports[0].${country}.slug`) || _.get(article, `tags.sports[0].en.slug`);
  // mms_tid is set to fwAssetId when it is ingested to MMS.
  configs.labels.defaults.mms_tid = video.fwAssetId || '';
  configs.labels.defaults.ns_st_ep = article.slug;
  configs.labels.defaults.ns_st_pr = sport || '';
  configs.live = video.beginPlaybackFrom ? true : false;
  return configs;
}

function googleAnalyticsConfig(configs, article, country) {
  const { tags } = article;
  const videoTypes = _.get(tags, 'videoTypes');

  const creationMethod = _.includes(videoTypes, 'vce-clip') ? 'vce' : 'manual';
  const type = _.includes(tags.contents, 'live') ? '[live]' : _.filter(videoTypes, (v) => v !== 'vce-clip');
  const sport = _.get(tags, `sports[0].${country}.slug`) || _.get(tags, `sports[0].en.slug`);
  const competition = _.get(tags, `competitions[0].${country}.slug`) || _.get(tags, `competitions[0].en.slug`);

  configs.eventLabel = `${creationMethod} - ${type[0]} - ${sport} - ${competition} - ${article.slug}`;

  configs.trackers.forEach(t => t.options = Object.assign({nonInteraction: false}, t.options));
  return configs;
}

function createPluginObject(pluginConfig) {
  const { article, csid, video, country, sovSeed, cuePoints, inline, customDimensions } = pluginConfig;
  const baseConfiguration = configEnv === 'test' ?
    _.merge(playerConfig[country].prod, playerConfig[country].test) : playerConfig[country].prod;

  const configuration = _.cloneDeep(baseConfiguration);

  const plugin = {};
  _.map(configuration, (configs, key) => {
    switch (key) {
    case 'freewheelConfig':
      plugin.freewheel = freewheelConfig(configs, country, video, csid, sovSeed, cuePoints, inline);
      return;
    //case 'comscoreConfig':
      //plugin.comscoreTracking = comscoreConfig(configs, article, video, country);
      //return;
    case 'googleAnalyticsConfig':
      plugin.googleAnalytics = googleAnalyticsConfig(configs, article, country);
      return;
    case 'adBlockerBlockerConfig':
      plugin.adBlockerBlocker = configs;
      return;
    case 'googleTagManagerConfig' :
      plugin.googleTagManager = configs;
      plugin.googleTagManager.customDimensions = customDimensions;
      return;
    default:
      return;
    }
  });

  return plugin;
}

function addPartnerConfig(playerPlugin, country, partnerId) {
  const partnerConfig = getPartnerConfig(country, partnerId);

  playerPlugin.domainRestrict = {
    // Merge partners urlhash with site urlhash.
    allowedDomains: _.concat(partnerConfig.urlHash || [], _.find(partnerConfigs[country], { name: 'Viasport' }).urlHash),
    errorMessage: 'Requested video is not available.',
  };

  return _.merge(playerPlugin, partnerConfig.customPlayerConfig);
}

// Merge configs if needed and build a object that suites the player.
export default function PlayerPluginConfigs(pluginConfig) {
  let playerPlugin = createPluginObject(pluginConfig);

  playerPlugin.mtgxSkin = {};
  playerPlugin.visualAdCues = {};

  if (pluginConfig.embed) {
    playerPlugin = addPartnerConfig(playerPlugin, pluginConfig.country, pluginConfig.routeParams.partnerId);
  }

  return playerPlugin;
}



// WEBPACK FOOTER //
// ./src/util/playerPluginConfigs.js